import { render, staticRenderFns } from "./TopChart.vue?vue&type=template&id=6239192a&"
import script from "./TopChart.vue?vue&type=script&lang=js&"
export * from "./TopChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports